import type { SpotlightProps } from '@atlaskit/onboarding/types';

export const headingTranslation = (value: SpotlightProps['heading']): string | undefined => {
	return value;
};
